import http from '../utils/http';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';
import { Promise as bbPromise } from 'bluebird';

export const defaultState = {
    entityName: 'devices',
    baseUrl: 'api/devices/',
    tableName: 'devicesTable',
    ...baseState,
    deviceStatusSummary: {},
    helpUrl: '/user-guide/guide/devices.html'
};

export const mutations = {
    ...baseMutations,
    setDeviceStatusSummary(state, value) {
        if (value) {
            state.deviceStatusSummary = value;
        } else {
            state.deviceStatusSummary = {};
        }
    }
};

export const actions = {
    ...baseActions,
    fetchDevices({ commit, dispatch, state }, { searchParams, filterParams }) {
        console.log('calling fetchDevices', searchParams, filterParams);
        const notifyConfig = {
            notifyRequestPending: true
        };
        return dispatch('fetchItems', {
            searchParams,
            filterParams,
            notifyConfig,
            saveParams: true
        }).then(res => {
            const { content, ...page } = res.data;
            commit('setItems', content);
            commit('setResponseQuery', { ...page });
            commit('setRequestQuery', {
                ...state.requestQuery,
                size: page.size,
                number: page.number
            });
        });
    },
    fetchDeviceStatusSummary({ commit, state }, { notifyConfig }) {
        console.log('calling fetchDeviceStatusSummary');
        return http
            .get(
                `${state.baseUrl}search/facets/?fields=healthCheckStatus.raw`,
                notifyConfig
            )
            .then(res => {
                if (res && res.data && res.data.facets) {
                    let summary = {};
                    const facets = res.data.facets;
                    for (const bucket of facets['healthCheckStatus.raw'][
                        'buckets'
                    ]) {
                        summary[bucket.key] = { count: bucket.doc_count };
                    }
                    commit('setDeviceStatusSummary', summary);
                    return summary;
                }
            });
    },
    postBulkActions({ dispatch, state }, { action, criteria, params }) {
        console.log('calling postBulkActions', action, criteria, params);
        const successMessage =
            'Bulk action was sent succefully. For job status, please click on the job status icon below.';
        const bulkActions = [
            'setClosedCaptioning',
            'setTalkingGuide',
            'rebootDevice',
            'resetDevice',
            'deleteByCriteria',
            'addTagsByCriteria',
            'removeTagsByCriteria'
        ];
        if (bulkActions.includes(action)) {
            let data = {
                action: action,
                criteria: criteria,
                params: params || {}
            };
            let actionUrl = 'actionByCriteria';
            if (action === 'deleteByCriteria') {
                actionUrl = action;
                data = { criteria };
            } else if (
                action === 'addTagsByCriteria' ||
                action === 'removeTagsByCriteria'
            ) {
                actionUrl = action;
                data = { criteria, tagIds: params };
            }
            return http
                .post(`${state.baseUrl}${actionUrl}`, data, {
                    notifyRequestPending: true,
                    successMessage
                })
                .then(() => {
                    return dispatch('showJobsDialog', null, { root: true });
                });
        }
    },
    fetchDevicesFromCDS({ dispatch }, { devices }) {
        // will fetch the latest device info directly from CDS
        // and bypass the DS-Explore caching
        console.log('Calling fetchDevicesFromCDS');
        return bbPromise.map(devices, item => {
            return dispatch(
                'device/fetchDevice',
                { deviceId: item.id },
                { root: true }
            ).then(res => res.data);
        });
    },
    fetchLastHealthPollDate({ state }, { notifyConfig }) {
        console.log('calling fetchLastHealthPollDate');

        return http
            .get(
                `${state.baseUrl}search/facets/?fields=healthCheckStatusDate`,
                { notifyRequestPending: true, ...notifyConfig }
            )
            .then(res => {
                if (res && res.data && res.data.facets) {
                    const items = res.data.facets.healthCheckStatusDate.buckets;
                    const max_count = Math.max(
                        ...items.map(item => item.doc_count)
                    );
                    const lastDate = items.find(
                        item => item.doc_count === max_count
                    );
                    return lastDate ? lastDate.key_as_string : '';
                }
            });
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
